import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IOptionGreekConstraintFormValues } from "../../Interfaces/optionGreek";

interface IOptionGreekSlice {
  constraintFormValues: IOptionGreekConstraintFormValues;
  constraintTableFlag: boolean;
}

const initialState: IOptionGreekSlice = {
  constraintFormValues: {} as IOptionGreekConstraintFormValues,
  constraintTableFlag: false,
};

const OptionGreekSlice = createSlice({
  name: "manual",
  initialState,
  reducers: {
    setOptionGreekConstraintFormValues: (
      store,
      action: PayloadAction<IOptionGreekConstraintFormValues>
    ) => {
      store.constraintFormValues = action.payload;
    },
    optionGreekConstraintFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.constraintFormValues = {
        ...store.constraintFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setOptionGreekConstraintTableFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      store.constraintTableFlag = action.payload;
    },
  },
});

export const {
  setOptionGreekConstraintFormValues,
  setOptionGreekConstraintTableFlag,
  optionGreekConstraintFormValuesChangeHandler,
} = OptionGreekSlice.actions;
export default OptionGreekSlice.reducer;
